import {OrganizationPermissionsEnum} from "@source/api/models/permissionsModels";
import nursingHomeStore from "@source/store/nursingHomeStore";
import userStore from "@source/store/userStore";
import {HOME_ROUTES} from "@source/utils/utils";

export type ConsentRouteKind =
  | "history"
  | "awaiting"
  | "templates"
  | "templateManage"
  | "categories"
  | "document"
  | "sign"
  | "resident"
  | "steps"
  | "presentation";

export const isConsentModuleEnabled = () => nursingHomeStore.activeNursingHome?.organization?.consentModule !== false;

export const hasConsentPermission = (permission: OrganizationPermissionsEnum) => userStore.isPermission(permission);
export const canViewConsentDocuments = () => hasConsentPermission(OrganizationPermissionsEnum.VIEW_CONSENT_DOCUMENTS);
export const canManageConsentDocuments = () => hasConsentPermission(OrganizationPermissionsEnum.MANAGE_CONSENT_DOCUMENTS);
export const canManageConsentTemplates = () => hasConsentPermission(OrganizationPermissionsEnum.MANAGE_CONSENT_TEMPLATES);
export const canViewConsentTemplates = () => hasConsentPermission(OrganizationPermissionsEnum.VIEW_CONSENT_TEMPLATES) || canManageConsentDocuments();
export const canViewConsentCategories = () => hasConsentPermission(OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES) || canViewConsentDocuments() || canManageConsentDocuments();
export const canShowConsentNavigation = () => isConsentModuleEnabled() && (
  !!userStore.getId() ||
  canViewConsentDocuments() ||
  canViewConsentTemplates() ||
  canViewConsentCategories()
);

export const getFirstConsentRoute = () => {
  if (canViewConsentDocuments()) return HOME_ROUTES.ConsentDocumentsHistory;
  return HOME_ROUTES.ConsentDocumentsAwaitingYourSign;
};

export const canAccessConsentRoute = (kind: ConsentRouteKind) => {
  if (kind === "document") return !!userStore.getId();
  if (!isConsentModuleEnabled()) return false;
  if (kind === "awaiting" || kind === "sign") return !!userStore.getId();
  if (kind === "templates") return canViewConsentTemplates();
  if (kind === "templateManage") return canManageConsentTemplates();
  if (kind === "categories") return canViewConsentCategories();
  if (kind === "steps") return canManageConsentDocuments();
  if (kind === "presentation") return canViewConsentDocuments() && canManageConsentDocuments();
  return canViewConsentDocuments();
};
